module.exports = __webpack_public_path__ + "static/media/tools-line-size.4d1d7dea.svg";